module.exports = __webpack_public_path__ + "static/media/totalPnts_1000_2500.2c7c0b02.png";